import { Redirect, Route, Switch } from "react-router-dom";
import { SitePage } from "pages/SitePage";

export const SiteRoutes = (): JSX.Element => {
  return (
    <Switch>
      <Route exact path="/pages/site/:siteId" component={SitePage} />
      {/* Redirect to the closest exact path above when an incorrect url is entered*/}
      <Redirect to="/pages/site/:siteId" from="/pages/site/:siteId" />
      <Redirect to="/pages" />
    </Switch>
  );
};
